module.exports = __webpack_public_path__ + "static/logo-js-eaddd9f76784c16d36e8bc00b49b6c33.png";